// extracted by mini-css-extract-plugin
module.exports = {"Spinner":"Spinner_Spinner__BWqNs","innerDiv":"Spinner_innerDiv__3jFKU","textAnimation":"Spinner_textAnimation__3jC6-","signInAnimation":"Spinner_signInAnimation__1gN6q"};